import { Button, useBreakpoint } from "@chakra-ui/react";
import { t } from "i18next";
import { useNavigate } from "react-router";
import { AddedBubbleIcon } from "../../../components/icons/AddedBubbleIcon";

// Figma: https://www.figma.com/design/z9Ut4lxLJQZK28vEZiHRwN/Monthly-rewards?node-id=122-3958

const BTN_RADIUS = "20px";

export function ClaimButton({
  isGold,
  isClaimed,
  isClaiming,
  readUrl,
  hasReadProgress = false,
  onClaim,
  onSubscribe,
}: {
  isGold: boolean;
  isClaimed: boolean;
  isClaiming: boolean;
  readUrl: string | null;
  /** When true on a claimed release, show "Continue reading" instead of "Start reading". */
  hasReadProgress?: boolean;
  onClaim: () => void;
  onSubscribe: () => void;
}) {
  const navigate = useNavigate();
  // Compact below Chakra's `xl` breakpoint (1280px at default font size) — matches
  // the grid breakdown in MonthlyComicsScreen where 4-col layout kicks in at xl+.
  const breakpoint = useBreakpoint({ ssr: false });
  const isCompact = !["xl", "2xl", "3xl", "4xl"].includes(breakpoint);
  const BTN_HEIGHT = isCompact ? "44px" : "48px";
  const BTN_FONT_SIZE = isCompact ? "16px" : "18px";

  if (!isGold) {
    return (
      <Button
        variant="primary"
        w="100%"
        h={BTN_HEIGHT}
        borderRadius={BTN_RADIUS}
        fontWeight={500}
        fontSize={BTN_FONT_SIZE}
        letterSpacing="0.75px"
        gc-testing-id="btnSubscribeToClaim"
        onClick={onSubscribe}
      >
        {t("screens.monthlyComics.claimWithGold")}
      </Button>
    );
  }
  if (isClaimed) {
    return (
      <Button
        w="100%"
        h={BTN_HEIGHT}
        borderRadius={BTN_RADIUS}
        bg="transparent"
        color="dune.100"
        fontWeight={500}
        fontSize={BTN_FONT_SIZE}
        letterSpacing="0.75px"
        border="1px solid"
        borderColor="success.500"
        _hover={{ bg: "transparent.success.10" }}
        _active={{ bg: "transparent.success.20" }}
        leftIcon={<AddedBubbleIcon boxSize="20px" color="success.500" />}
        gc-testing-id="btnClaimed"
        onClick={() => readUrl && navigate(readUrl)}
      >
        {hasReadProgress
          ? t("screens.monthlyComics.continueReading")
          : t("screens.monthlyComics.startReading")}
      </Button>
    );
  }
  return (
    <Button
      variant="primary"
      w="100%"
      h={BTN_HEIGHT}
      borderRadius={BTN_RADIUS}
      fontWeight={500}
      fontSize={BTN_FONT_SIZE}
      letterSpacing="0.75px"
      isLoading={isClaiming}
      onClick={onClaim}
      gc-testing-id="btnClaimNow"
    >
      {t("screens.monthlyComics.claim")}
    </Button>
  );
}
